module.exports = __webpack_public_path__ + "img/tema1.4413b5c3.svg";